/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvitedMemberVo } from './InvitedMemberVo';
import {
    InvitedMemberVoFromJSON,
    InvitedMemberVoFromJSONTyped,
    InvitedMemberVoToJSON,
    InvitedMemberVoToJSONTyped,
} from './InvitedMemberVo';

/**
 * 
 * @export
 * @interface CommissionInviteStatsPageItemVo
 */
export interface CommissionInviteStatsPageItemVo {
    /**
     * 合作会员id
     * @type {number}
     * @memberof CommissionInviteStatsPageItemVo
     */
    userId?: number;
    /**
     * 合作会员编号
     * @type {string}
     * @memberof CommissionInviteStatsPageItemVo
     */
    userCode?: string;
    /**
     * 合作会员名
     * @type {string}
     * @memberof CommissionInviteStatsPageItemVo
     */
    userName?: string;
    /**
     * 合作会员登录账号
     * @type {string}
     * @memberof CommissionInviteStatsPageItemVo
     */
    account?: string;
    /**
     * 邀新会员列表（通过该合作会员推荐码注册的会员，含当年无业绩的）
     * @type {Array<InvitedMemberVo>}
     * @memberof CommissionInviteStatsPageItemVo
     */
    invitedMembers?: Array<InvitedMemberVo>;
}

/**
 * Check if a given object implements the CommissionInviteStatsPageItemVo interface.
 */
export function instanceOfCommissionInviteStatsPageItemVo(value: object): value is CommissionInviteStatsPageItemVo {
    return true;
}

export function CommissionInviteStatsPageItemVoFromJSON(json: any): CommissionInviteStatsPageItemVo {
    return CommissionInviteStatsPageItemVoFromJSONTyped(json, false);
}

export function CommissionInviteStatsPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionInviteStatsPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'account': json['account'] == null ? undefined : json['account'],
        'invitedMembers': json['invitedMembers'] == null ? undefined : ((json['invitedMembers'] as Array<any>).map(InvitedMemberVoFromJSON)),
    };
}

export function CommissionInviteStatsPageItemVoToJSON(json: any): CommissionInviteStatsPageItemVo {
    return CommissionInviteStatsPageItemVoToJSONTyped(json, false);
}

export function CommissionInviteStatsPageItemVoToJSONTyped(value?: CommissionInviteStatsPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'account': value['account'],
        'invitedMembers': value['invitedMembers'] == null ? undefined : ((value['invitedMembers'] as Array<any>).map(InvitedMemberVoToJSON)),
    };
}

